import React from 'react';
import * as Yup from 'yup';
import { CheckboxWithLabel, SubmitButton, useAlert } from '@uplift/ui-v2';
import { CollaborativeAgreementUnsigned } from '@uplift/api';
import { useSignCollaborativeAgreementMutation, useUserDisplayNameQuery } from '@uplift/queries';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { Formik } from 'formik';
import { useCurrentuser } from '@uplift/contexts';


export const SignDocumentControls: React.VFC<{
  document: CollaborativeAgreementUnsigned;
  onSign: (agreementId: string) => void;
}> = ({ document, onSign }) => {
  const me = useCurrentuser();
  const { data: providerName } = useUserDisplayNameQuery(me.id, { suspense: true });
  const signMutation = useSignCollaborativeAgreementMutation(me.id);
  const alert = useAlert();

  return (
    <Formik
      initialValues={{ fullLegalName: providerName.full, agree: false }}
      validationSchema={Yup.object().shape({
        agree: Yup.boolean().oneOf([ true ], 'You must agree to sign the agreement'),
      })}
      onSubmit={async () => {
        const signedAgreementId = await signMutation.mutateAsync({
          agreementTemplateId: document.agreementTemplateId,
          collaborativeMatchId: document.collaborativeMatchId,
        });

        onSign(signedAgreementId);
        alert.success('Successfully signed the agreement');
      }}
    >
      <Box>
        <Divider />
        <Box sx={{ p: 3, pt: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography variant="overline" color="secondary">Your signature</Typography>
          <Paper variant="outlined" sx={{ p: 1.5 }}>
            <Typography>
              {providerName.fullLegalName}
            </Typography>
          </Paper>
          <CheckboxWithLabel showError name="agree" label="By checking this, I agree this constitutes my legal electronic signature on this collaborative practice agreement." />
          <Box>
            <SubmitButton>Sign agreement</SubmitButton>
          </Box>
        </Box>
      </Box>
    </Formik>
  );
};
